export const RECEIVE_USERINFO = "receive_userinfo";// 接收用户信息
export const GET_USER_MENU_PERMS = "getUserMenusPerms1";// 获取菜单栏信息
export const GET_OA_WAITCOUNT = "getOAWaitCount"; //查询OA待办任务数量
export const GET_TOOLTIP_INFO = "getTooltipInfo";//查询提示信息
export const GET_USER_ORGS = "getOrgSelect";//获取用户任职机构列表



// WEBPACK FOOTER //
// ./src/store/mutation-types.js